import { appData } from '@/mocks/home';

export default function AppDownload() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          {appData.title}
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">{appData.subtitle}</p>

        <div className="max-w-[900px] mx-auto bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            {/* Text */}
            <div className="flex-1 p-8 md:p-10 text-background-50">
              <h3 className="font-heading text-xl md:text-2xl font-bold mb-4">
                随时随地，一瓜不落
              </h3>
              <p className="text-sm text-background-50/90 leading-relaxed mb-5">
                {appData.description}
              </p>
              <div className="flex flex-wrap gap-2 mb-6">
                {appData.features.map((feat, i) => (
                  <span
                    key={i}
                    className="px-3 py-1 bg-background-50/20 text-background-50 text-xs rounded-full whitespace-nowrap"
                  >
                    {feat}
                  </span>
                ))}
              </div>
              <div className="flex items-center gap-4 text-xs text-background-50/80 mb-6">
                <span>版本 {appData.version}</span>
                <span>大小 {appData.size}</span>
                <span>更新于 {appData.updateDate}</span>
              </div>
              <button className="px-6 py-3 bg-background-50 text-primary-600 font-bold text-sm rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-line mr-2"></i>
                安卓下载
              </button>
            </div>

            {/* Visual */}
            <div className="flex-1 p-8 flex justify-center">
              <div className="w-48 h-48 md:w-56 md:h-56 rounded-3xl bg-background-50/20 flex items-center justify-center">
                <i className="ri-smartphone-line text-background-50/60 text-6xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}